module.exports = __webpack_public_path__ + "img/dbscarlett.b4e67682.png";